import {
  SEND_CHAT_MESSAGE,
  SEND_CHAT_MESSAGE_SUCCESS,
  SEND_CHAT_MESSAGE_ERROR,
  SEND_CHAT_MESSAGE_STATUS,
  SEND_CHAT_MESSAGE_STREAM_CHUNK,
  CLEAR_CHAT_HISTORY,
  TOGGLE_CHAT_WINDOW,
  SET_CHAT_WINDOW_OPEN,
  SET_CHAT_LOADING,
  SET_CONVERSATION_ID,
  LOAD_CONVERSATIONS,
  LOAD_CONVERSATIONS_SUCCESS,
  LOAD_CONVERSATIONS_ERROR,
  LOAD_CONVERSATION,
  LOAD_CONVERSATION_SUCCESS,
  LOAD_CONVERSATION_ERROR,
  DELETE_CONVERSATION,
  DELETE_CONVERSATION_SUCCESS,
  DELETE_CONVERSATION_ERROR,
  UPDATE_CONVERSATION_TITLE,
  RESET_CHAT_SCOPE,
  SET_CHAT_FULLSCREEN,
} from './constants'

export const sendChatMessage = (
  message,
  conversationId,
  companyCode,
  context
) => ({
  type: SEND_CHAT_MESSAGE,
  message,
  conversationId,
  companyCode,
  ...(context ? { context } : {}),
})

export const sendChatMessageSuccess = (response) => ({
  type: SEND_CHAT_MESSAGE_SUCCESS,
  response,
})

export const sendChatMessageError = (error) => ({
  type: SEND_CHAT_MESSAGE_ERROR,
  error,
})

export const sendChatMessageStatus = (status) => ({
  type: SEND_CHAT_MESSAGE_STATUS,
  status,
})

export const sendChatMessageStreamChunk = (chunk) => ({
  type: SEND_CHAT_MESSAGE_STREAM_CHUNK,
  chunk,
})

export const clearChatHistory = () => ({
  type: CLEAR_CHAT_HISTORY,
})

export const toggleChatWindow = () => ({
  type: TOGGLE_CHAT_WINDOW,
})

export const setChatWindowOpen = (isOpen) => ({
  type: SET_CHAT_WINDOW_OPEN,
  isOpen,
})

export const setChatLoading = (isLoading) => ({
  type: SET_CHAT_LOADING,
  isLoading,
})

export const setConversationId = (id) => ({
  type: SET_CONVERSATION_ID,
  id,
})

export const loadConversations = (companyCode) => ({
  type: LOAD_CONVERSATIONS,
  companyCode,
})

export const loadConversationsSuccess = (conversations) => ({
  type: LOAD_CONVERSATIONS_SUCCESS,
  conversations,
})

export const loadConversationsError = (error) => ({
  type: LOAD_CONVERSATIONS_ERROR,
  error,
})

export const loadConversation = (conversationId, companyCode) => ({
  type: LOAD_CONVERSATION,
  conversationId,
  companyCode,
})

export const loadConversationSuccess = (conversation) => ({
  type: LOAD_CONVERSATION_SUCCESS,
  conversation,
})

export const loadConversationError = (error) => ({
  type: LOAD_CONVERSATION_ERROR,
  error,
})

export const deleteConversation = (conversationId, companyCode) => ({
  type: DELETE_CONVERSATION,
  conversationId,
  companyCode,
})

export const deleteConversationSuccess = (conversationId) => ({
  type: DELETE_CONVERSATION_SUCCESS,
  conversationId,
})

export const deleteConversationError = (error) => ({
  type: DELETE_CONVERSATION_ERROR,
  error,
})

export const updateConversationTitle = (conversationId, title) => ({
  type: UPDATE_CONVERSATION_TITLE,
  conversationId,
  title,
})

export const resetChatScope = (scopeCode) => ({
  type: RESET_CHAT_SCOPE,
  scopeCode,
})

export const setChatFullscreen = (isFullscreen) => ({
  type: SET_CHAT_FULLSCREEN,
  isFullscreen,
})
